/* eslint-disable @typescript-eslint/naming-convention */
export const PURGE_LISTS = "@LISTS/PURGE_LISTS";
export type PURGE_LISTS = typeof PURGE_LISTS;

export const SET_LISTS = "@LISTS/SET_LISTS";
export type SET_LISTS = typeof SET_LISTS;

export const SET_CURRENT_LIST = "@LISTS/SET_CURRENT_LIST";
export type SET_CURRENT_LIST = typeof SET_CURRENT_LIST;

export const UPDATE_CUSTOMER_REFERENCE = "@LISTS/UPDATE_CUSTOMER_REFERENCE";
export type UPDATE_CUSTOMER_REFERENCE = typeof UPDATE_CUSTOMER_REFERENCE;

export const UPDATE_LIST_ROW = "@LISTS/UPDATE_LIST_ROW";
export type UPDATE_LIST_ROW = typeof UPDATE_LIST_ROW;

export const UPDATE_LIST_LINE = "@LISTS/UPDATE_LIST_LINE";
export type UPDATE_LIST_LINE = typeof UPDATE_LIST_LINE;
